import { render } from "./CurrentCensusTab.vue?vue&type=template&id=13a33564&scoped=true&ts=true"
import script from "./CurrentCensusTab.vue?vue&type=script&lang=ts"
export * from "./CurrentCensusTab.vue?vue&type=script&lang=ts"

import "./CurrentCensusTab.vue?vue&type=style&index=0&id=13a33564&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a33564"]])

export default __exports__